<template>
  <form :class="style['form-wrap']" @submit.prevent="sendForm">
    <h2 :class="style.title">{{ $t('search_area_form.select_prefecture_area') }}</h2>
    <text-input
      v-model="searchAreaForm.prefecture.text"
      :placeholder="$t('search_area_form.prefecture')"
      read-only
      @click="openOptionPicker('prefecture', 'pickupPrefectures')"
    />
    <text-input
      v-model="searchAreaForm.area.text"
      :placeholder="$t('search_area_form.area')"
      read-only
      :disabled="!searchAreaForm.prefecture.text"
      @click="openOptionPicker('area', 'searchAreas')"
    />
    <div v-if="error" class="error-text">
      <span>{{ error }}</span>
    </div>
    <div>
      <button v-theme :class="style['btn-pink']" :disabled="!isValidForm" type="submit">
        {{ $t('next') }}
      </button>
    </div>
  </form>
</template>

<script>
import TextInput from 'UtilityComponents/TextInput.vue'
import style from './scss/_pages.scss'
import { EventBus } from 'ChatWidget/EventBus'
import { Chat } from 'src/apis'
import { mapActions, mapGetters, mapState } from 'pinia'
import { useBottomPanelStore } from 'Store/bottom-panel'
import { useChatStore } from 'Store/chat'
import { useDetailsPageStore } from 'Store/details-page'
import { useFormStore } from 'Store/form'

export default {
  components: {
    TextInput
  },

  setup() {
    return {
      bottomPanelStore: useBottomPanelStore(),
      chatStore: useChatStore(),
      detailsPageStore: useDetailsPageStore(),
      formStore: useFormStore()
    }
  },

  data() {
    return {
      error: '',
      style
    }
  },

  computed: {
    ...mapState(useFormStore, {
      searchAreaForm: 'searchAreaForm'
    }),

    isPrefecturesEmpty() {
      return !this.bottomPanelStore.pickupPrefectures.length
    },

    isValidForm() {
      return this.searchAreaForm.prefecture.text && this.searchAreaForm.area.text
    }
  },

  watch: {
    'searchAreaForm.prefecture.id'() {
      const prefectureId = this.searchAreaForm.prefecture.id
      this.bottomPanelStore.setSearchAreas(
        this.bottomPanelStore.searchAreasById[prefectureId] || []
      )
      this.formStore.setActiveField('area')
      this.formStore.setFormFieldValue({ id: null, text: null })
    }
  },

  created() {
    this.$rollbar.info(`searchAreaForm created ${this.chatStore.chatId}`)
    this.setActiveField('prefecture')
    this.setFormFieldValue({ id: null, text: null })
    this.setActiveField('area')
    this.setFormFieldValue({ id: null, text: null })
    this.bottomPanelStore.setPickupPrefectures([])
    this.bottomPanelStore.setSearchAreasById([])

    Chat.getPrefecturesAndAreas(this.chatStore.chatId).then((res) => {
      this.bottomPanelStore.setPickupPrefectures(res.data.prefectures)
      this.bottomPanelStore.setSearchAreasById(res.data.areas)
    })
  },

  methods: {
    ...mapActions(useFormStore, ['setActiveField', 'setFormFieldValue']),

    sendForm() {
      const formData = {
        prefecture: this.searchAreaForm.prefecture.id,
        area: this.searchAreaForm.area.id
      }
      this.detailsPageStore.closeDetailsPageShown()
      EventBus.$emit('pageDisabledActionWidget')

      const message = [
        `${this.$t('search_area_form.prefecture')}: ${this.searchAreaForm.prefecture.text}`,
        `${this.$t('search_area_form.area')}: ${this.searchAreaForm.area.text}`
      ].join('\n')
      Chat.sendMessage(message, { messageAction: JSON.stringify(formData) })
    },

    openOptionPicker(field, data) {
      this.bottomPanelStore.setBottomPanelDisplayList(data)
      this.formStore.setActiveField(field)
      this.bottomPanelStore.setBottomPanelComponent('OptionPickerPanel')
      this.$rollbar.info(`searchAreaForm openOptionPicker ${this.chatStore.chatId}`)
    }
  }
}
</script>
